export default __webpack_public_path__ + "static/media/Asset2_lrg.0504f4ec.png";